module.exports = __webpack_public_path__ + "img/img_join_04.7ba6aadb.jpg";